<template>
  <a :href="url">
    <div class="card">
      <el-card :body-style="{ padding: '0px' }">
        <img
            :src="coverUrl"
            class="cover"

        />
        <div style="padding: 14px">
          <h2 class="title">{{title}}</h2>
          <span class="intro">{{intro}}</span>
        </div>
      </el-card>
    </div>
  </a>
</template>

<script>
export default {
  name: "go_sync",
  data() {
    return {
      title: "面试必问？一文带你速通Go语言并发 ",
      intro: "语言级的并发是go语言的一大特点, 阅读本文掌握go语言并发! ",
      url: "posts/go_sync.html",
      coverUrl: "img/go_cover.png"
    }
  }
}
</script>

<style scoped>
a {
  margin-top: 5%;
  display: block;
}

.card :hover {
  overflow: visible;
  transform: scale(1.1);
  transition: all 0.6s;
}
img{
  width: 100%;

}
.cover{
}
.title{
  color: #303133;
  font-size: small;

}
.intro{
  color: #909399;
  margin-left: 3%;
  font-size: smaller;

}
.el-card{
  height:300px;
  width: 250px;
}
</style>